import { AssetConfig } from "../index";

export const VehicleAssetConfig: AssetConfig = {
    name: {type: "STRING",required: true,editable: true,label: "Name",rank: 1},
    registrationNumber: {type: "STRING", required: false, editable: true, label: "Registration",rank: 2},
    // group: {type: "SELECT",editable: true, label: "Vehicle group",rank: 3},
    fleetGroupId: {type: "SELECT",editable: true, label: "Vehicle group",rank: 3},
    fuelTypeId: {type: "SELECT", editable: true, label: "Fuel type", rank: 4},
    description: {type: "STRING",required: false,editable: true,label: "Description",rank: 5},
    isActive: {type: "BOOLEAN",required: true,editable: true,label: "Active",rank: 6},
    useForRebateClaim: {type: "BOOLEAN",required: true,editable: true,label: "Eligible for tax rebate",rank: 8},
    measurementUnit: {type: "SELECT",editable: true,label: "Measurement units",rank: 7},
    expectedConsumptionRate: {type: "NUMBER", editable: true, label: "Expected consumption rate", rank: 9},
    fuelCapacity: {type: "NUMBER", editable: true, decimalPrecision: 0, label: "Fuel capacity",rank: 10},
    lastOdometer: {type: "NUMBER", editable: true, decimalPrecision: 0,label: "Last odometer",rank: 11},
    // lastOdometerDate: {type: "DATE", editable: false,label: "Last odometer date",rank: 11},
} 
